<template>
  <section class="meta-section" @contextmenu.prevent="contextMenuHandler">
    <Header class="meta-header" :openChannelId="channelId" />
    <div class="lobby-container">
      <div class="toolbox-container" v-if="!blitzarMeetingRoomID">
        <label>{{ activityData.activity }}</label>
        <i
          title="Microfone"
          :class="{ 'fas fa-microphone': !isLocalStreamMuted, 'fas fa-microphone-slash': isLocalStreamMuted }"
          @click.prevent="toggleLocalStreamAudioTrack('BlitzarTalk')"
          style="width: 26px; text-align: center"
          v-if="blitzarTalkID"></i>
        <ion-icon title="Audio" :name="allMuted ? 'volume-mute' : 'volume-high'" style="font-size: 2rem; cursor: pointer" @click="toggleMutePeers" v-if="blitzarTalkID"></ion-icon>
        <!-- <button class="button" @click="blitzarTalkID='';isUserInLobby=false" v-if="blitzarTalkID">SAIR</button> -->
        <button
          class="button"
          @click="
            blitzarTalkID = activityData.activity_id;
            isUserInLobby = true;
          "
          v-else>
          ENTRAR
        </button>
        <!-- chat btn -->
        <div title="Chat" @click="showChatbox = !showChatbox">
          <i class="fas fa-comment" v-if="!showChatbox"></i>
          <i class="fas fa-comment-slash" v-else></i>
        </div>
      </div>
      <div class="avatar-list-container" v-if="lobbyStreams.length">
        <!-- <img :src="$store.state.user.picture" v-if="isUserInLobby" /> -->
        <img v-for="user in lobbyStreams" :key="user.id" :src="user.image" v-show="user.image" />
      </div>
      <div class="BlitzarTalk-container">
        <BlitzarTalk
          ref="BlitzarTalk"
          :roomId="blitzarTalkID"
          :cameraHeight="80"
          :userName="$store.state.user.name ? $store.state.user.name : ''"
          :userImage="$store.state.user.picture"
          :isVerticalOrientation="false"
          v-if="blitzarTalkID"
          @joined-room="joinedBlitzarTalk" />
      </div>
      <VueDragResize class="meta-chatbox" drag-handle=".meta-chatbox-drag" :parentLimitation="true" :x="metaChatbox_x" :y="metaChatbox_y" @resizing="chatboxResizing" v-if="showChatbox">
        <div class="meta-chatbox-drag"></div>
        <Sidebox ref="sidebox" :channel="$route.params.stream" v-if="$route.params.stream" />
      </VueDragResize>
    </div>

    <div class="base-areas">
      <img ref="baseImg" class="baseImg" :src="baseImg" />
      <div class="defined-area" :style="{ top: `${entity.position.y * 100}%`, left: `${entity.position.x * 100}%` }" v-for="entity in entities" :key="entity.id" @click="entityClickHandler(entity)">
        <img class="user-image" :src="entity.properties.user.image" v-if="entity.properties.user.image" />
        <img class="plus-image" src="https://proto-assets.s3.amazonaws.com/blitzar-demo/assets/plus-5-64.png" v-else />
      </div>
    </div>

    <div class="meta-modal-container" :style="{ left: switched ? '86%' : '0%', zIndex: switched ? '0' : '2' }" v-show="showModal && false">
      <div class="meta-modal-switch-btn" :style="{ top: switched ? '99px' : '0' }" @click.prevent="switchMode">
        <ion-icon :name="switched ? 'apps-sharp' : 'barcode-outline'" style="font-size: 2rem; cursor: pointer"></ion-icon>
      </div>
      <!-- <iframe id="zoomIframe" style="width:100%;height:100%" :src="zoomSrc" allow="camera; microphone; fullscreen" frameborder="0" v-show="showZoomIframe && !showBlitzarMeeting"></iframe> -->
      <div class="BlitzarMeeting-modal-container" v-if="blitzarMeetingRoomID">
        <!-- <BlitzarMeeting ref="BlitzarMeeting" :roomId="blitzarMeetingRoomID" :userName="$store.state.user.name ?$store.state.user.name:''" :userImage="$store.state.user.picture ?$store.state.user.picture:''" :cameraHeight="cameraHeight" :isVerticalOrientation="false" v-if="showBlitzarMeeting" @joined-room="resize" @left-room="leftRoom" @share-started="screenShareStarted" @share-ended="screenShareEnded" @close-modal="closeModal" /> -->
      </div>
      <!-- <div class="BlitzarMeeting-tools-btns" :style="{bottom:switched?'4px':'36px'}" v-if="blitzarMeetingRoomID">
        <i class="" :class="{'fas fa-microphone':!isLocalStreamMuted,'fas fa-microphone-slash':isLocalStreamMuted}" @click.prevent="toggleLocalStreamAudioTrack('BlitzarMeeting')"></i>
        <i class="" :class="{'fas fa-video':!isLocalStreamDisabled,'fas fa-video-slash':isLocalStreamDisabled}" @click.prevent="toggleLocalStreamVideoTrack" v-show="!switched"></i>
        <i class="fas fa-times" v-if="isLocalScreenSharingActive" @click.prevent="stopScreenSharing"></i>
        <i class="fas fa-tv" v-else @click.prevent="shareScreen"></i>
        <i class="fas fa-sign-out-alt" style="color:#e11" @click.prevent="closeModal"></i>
      </div> -->
    </div>
    <div class="meta-user-profile-wrapper" v-show="showUserDetails">
      <div class="meta-user-profile-close-btn" @click.prevent="showUserDetails = false"></div>
      <div class="meta-user-profile-container">
        <img :src="currentUser.image" v-if="currentUser && currentUser.image" />
        <label v-if="currentUser && currentUser.name">{{ currentUser.name }}</label>
        <button class="button" @click.stop="openChannel(currentUser.user_id)">MENSAGEM</button>
      </div>
    </div>

    <!-- <Sidebox style="position:fixed;top:120px;left:10px;height:60vh;width:100%;max-width:400px" :showQA="false" v-if="true" /> -->

    <!-- <Spinner :showSpinner="showSpinner" style="background:#0007;height:100%;padding-top:20%" /> -->
    <div class="iframe-footer-wrapper" style="z-index: 1">
      <Footer />
    </div>
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api';
import Spinner from '@/components/ui/Spinner.vue';
import BlitzarTalk from '@/components/webrtc/BlitzarTalk.vue';
import Sidebox from '@/components/chat_qa_box/Sidebox.vue';
import VueDragResize from 'vue-drag-resize';

const BlitzarMeeting = () => import('@/components/webrtc/BlitzarMeeting.vue');

export default {
  name: 'Meta',
  components: {
    Header,
    Footer,
    BlitzarMeeting,
    BlitzarTalk,
    Spinner,
    Sidebox,
    VueDragResize,
  },
  data() {
    return {
      activityData: { images: { bg: '' } },
      baseImg: 'https://proto-assets.s3.amazonaws.com/blitzar-demo/assets/sketch_bg.jpg',
      entities: [],
      meta: [],
      activityID: '10f98ad0-ac51-11eb-9fc3-cb273085eff7',
      metaLoaded: false,
      showModal: false,
      showZoomIframe: false,
      showUserDetails: false,
      showSpinner: false,
      showBlitzarMeeting: false,
      currentEntityID: '',
      currentMetaID: '',
      currentUser: null,
      updaterInterval: null,
      channelId: '',
      zoomSrc: 'https://meet-zoom.blitzar.com.br',
      blitzarMeetingRoomID: '',
      cameraHeight: 200,
      isLocalStreamDisabled: false,
      isLocalStreamMuted: false,
      isLocalScreenSharingActive: false,
      isUserInLobby: false,
      blitzarTalkID: '',
      lobbyStreams: [],
      allMuted: false,
      switched: false,
      metaChatbox_x: 300,
      metaChatbox_y: 300,
      showChatbox: false,
    };
  },

  methods: {
    loadActivity() {
      api
        .get(`activity/${this.$route.params.stream}`)
        .then((response) => {
          this.activityData = { ...this.activityData, ...response.data };
          this.activityData.images = JSON.parse(response.data.images);
          this.activityData.property = JSON.parse(response.data.property);

          this.entities = this.activityData.property.meta_entities;

          this.apiGetMeta();
        })

        .catch((err) => {
          console.error(err);
        });
    },
    apiGetMeta() {
      api
        .get(`event/${this.$store.state.eventId}/activity/${this.$route.params.stream}/meta`)
        .then((response) => {
          // console.log('apiGetMeta response: ', { response });
          let metaData = response.data.map((item) => {
            item.position = JSON.parse(item.position);
            item.properties = JSON.parse(item.properties);
            return item;
          });
          this.meta = [...metaData];

          this.entities.map((entity) => {
            entity.properties.user = {};
            metaData.map((meta) => {
              if (meta.properties.taken_entity_id == entity.meta_id) {
                entity.properties.user = meta.properties.user;
              }
              return meta;
            });
            return entity;
          });

          this.$nextTick((_) => {
            this.metaLoaded = true;
          });

          // this.apiDeleteMeta(this.meta[0]);
        })
        .catch((err) => console.error(err));
    },
    apiPostMeta(entity_id) {
      let payload = {
        position: JSON.stringify({ group: 'Conference_B', x: 0.3, y: 0.8 }),
        properties: JSON.stringify({
          taken_entity_id: entity_id,
          user: {
            user_id: this.$store.state.user.id,
            name: this.$store.state.user.name,
            image: this.$store.state.user.picture,
          },
        }),
      };
      api.post(`event/${this.$store.state.eventId}/activity/${this.$route.params.stream}/meta`, payload).catch((err) => console.error(err));
    },
    apiPutMeta(meta) {
      let payload = {
        properties: JSON.stringify({
          user: {
            user_id: this.$store.state.user.id,
            name: this.$store.state.user.name,
            image: this.$store.state.user.picture,
            email: null,
            telephone: null,
            company: null,
            role: null,
            nickname: null,
            about_me: null,
            link: null,
            other: null,
          },
        }),
      };
      api.put(`event/${this.$store.state.eventId}/activity/${this.$route.params.stream}/meta/${meta.meta_id}`, payload).catch((err) => console.error(err));
    },
    apiDeleteMeta(meta) {
      if (!meta.meta_id) return;
      api
        .delete(`event/${this.$store.state.eventId}/activity/${this.$route.params.stream}/meta/${meta.meta_id}`)
        .then((response) => {
          // console.log('apiDeleteMeta response: ', { response });
        })
        .catch((err) => console.error(err));
    },
    entityClickHandler(entity) {
      if (this.$store.state.user.inMeeting && !entity.properties.user.user_id) {
        this.closeModal();
      }
      this.currentEntityID = entity.meta_id;

      this.$nextTick((_) => {
        api
          .get(`event/${this.$store.state.eventId}/activity/${this.$route.params.stream}/meta/`)
          .then((response) => {
            let metaData = response.data.map((item) => {
              // console.log({ item });
              item.position = JSON.parse(item.position);
              item.properties = JSON.parse(item.properties);
              return item;
            });
            this.meta = [...metaData];

            this.entities.map((ent) => {
              metaData.map((meta) => {
                if (ent.meta_id == meta.properties.taken_entity_id) {
                  ent.properties.user = meta.properties.user;
                }
                return meta;
              });
              return entity;
            });

            this.metaLoaded = true;

            if (!entity.properties.user.user_id) {
              let payload = {
                position: JSON.stringify(entity.position),
                properties: JSON.stringify({
                  taken_entity_id: entity.meta_id,
                  user: {
                    user_id: this.$store.state.user.id,
                    name: this.$store.state.user.name,
                    image: this.$store.state.user.picture,
                  },
                }),
              };
              api
                .post(`event/${this.$store.state.eventId}/activity/${this.$route.params.stream}/meta/`, payload)
                .then((response) => {
                  // console.log('entityClickHandler apiPostMeta ADD USER response: ', { response });
                  this.currentMetaID = response.data.meta_id;
                  // this.showZoomIframe = true;
                  // this.joinZoomMeeting(entity);
                  // this.joinBlitzarMeeting(entity);

                  this.blitzarTalkID = '';
                  this.showModal = !this.showModal;

                  this.$root.$emit('openJitsi', { roomID: entity.position.group, roomName: entity.position.name, metaActivityID: this.$route.params.stream, metaID: this.currentMetaID });
                  this.apiGetMeta();
                })
                .catch((err) => console.error(err));
            } else {
              this.currentUser = entity.properties.user;
              this.apiGetMeta();
              this.showUserDetails = true;
            }
          })
          .catch((err) => console.error(err));
      });
    },
    messageReceiver(e) {
      // console.log('messageReceiver', e.data);
      if (e.data.meetingReady != undefined && !e.data.meetingReady) {
        // console.log("messageReceiver meetingReady", e.data);
      }
    },
    joinZoomMeeting(entity) {
      this.showZoomIframe = true;
      api
        .get(`activity/${entity.activity_id}`)
        .then((response) => {
          let zoomURL = JSON.parse(response.data.property).meetLink;
          this.$nextTick((_) => {
            if (document.getElementById('zoomIframe')) {
              document.getElementById('zoomIframe').contentWindow.postMessage(
                {
                  sender: 'conference',
                  user: this.$store.state.user.name,
                  language: 'pt-PT',
                  msg: zoomURL ? zoomURL : 'https://zoom.us/j/97898388259?pwd=dEF0cmZQNWliZlZodjcwQWRZZWdkQT09', //ZOOM Meeting URL
                },
                '*',
              );
            }
            // console.log('postMessage', this.activityData.property.meetLink);
          });
        })
        .catch(() => {});
    },
    joinBlitzarMeeting(entity) {
      this.blitzarMeetingRoomID = entity.position.group;
      this.showBlitzarMeeting = true;
      this.isLocalStreamMuted = false;
      this.apiGetMeta();
    },
    joinedBlitzarTalk(data) {
      this.lobbyStreams = data;
      this.toggleLocalStreamAudioTrack('BlitzarTalk');
    },
    shareScreen() {
      this.$refs.BlitzarMeeting.shareScreen();
    },
    stopScreenSharing() {
      this.$refs.BlitzarMeeting.stopScreenSharing();
    },
    screenShareStarted() {
      this.isLocalScreenSharingActive = true;
    },
    screenShareEnded() {
      this.isLocalScreenSharingActive = false;
    },
    closeWindowConfirm(evt) {
      if (this.$store.state.user.inMeeting || this.showBlitzarMeeting || this.showZoomIframe) {
        this.closeModal();
        const unsaved_changes_warning = 'Você ainda tem uma sessão aberta. Deseja encerrar?';
        evt.returnValue = unsaved_changes_warning;
        return 'Você ainda tem uma sessão aberta. Deseja encerrar?';
      }
    },
    closeModal() {
      // console.log('closeModal');
      if (this.$store.state.user.inMeeting) {
        this.$root.$emit('leaveJitsiRoom');
        this.$store.commit('setUserInMeeting', false);

        this.$nextTick((_) => {
          this.blitzarMeetingRoomID = '';
          this.currentEntityID = '';
          this.showBlitzarMeeting = false;
          this.showModal = false;
          this.allMuted = false;
          this.isLocalStreamMuted = false;
          this.isLocalStreamDisabled = false;
          this.isLocalScreenSharingActive = false;
          this.apiGetMeta();
          this.blitzarTalkID = this.$route.params.stream;
          this.switched = false;
          this.isUserInLobby = true;
        });
      } else if (this.showZoomIframe) {
        api
          .delete(`event/${this.$store.state.eventId}/activity/${this.$route.params.stream}/meta/${this.currentMetaID}`)
          .then((response) => {
            // console.log('closeModal DELETE META: ', { response });
            document.getElementById('zoomIframe').contentWindow.postMessage(
              {
                sender: 'logout',
                user: this.$store.state.user.name,
                language: 'pt-PT',
                msg: 'logout',
              },
              '*',
            );
            let tempZoomSrc = this.zoomSrc;
            this.zoomSrc = '';
            this.$nextTick((_) => {
              this.currentEntityID = '';
              this.showZoomIframe = false;
              this.zoomSrc = tempZoomSrc;
              this.showModal = false;

              this.apiGetMeta();
            });
          })
          .catch((err) => console.error(err));
      } else {
        this.currentEntityID = '';
        this.currentMetaID = '';
        this.currentUser = null;
        this.showZoomIframe = false;
        this.showModal = false;
      }
    },
    openChannel(user_id) {
      api
        .post(`event/${this.$store.state.eventId}/createTalkChannel`, {
          user_id: user_id,
          channelName: user_id > this.$store.state.user.id ? user_id + this.$store.state.user.id : this.$store.state.user.id + user_id,
        })
        .then((response) => {
          if (response.data) {
            this.$nextTick((_) => {
              this.channelId = response.data.talk_channel_id;
              document.getElementById('messagesContainer').focus();
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    sketchLoaded() {
      this.showSpinner = false;
    },
    resize() {
      if (this.$refs.BlitzarMeeting) {
        this.cameraHeight = window.innerWidth / (16 / 9) / 2.73;
      }
    },
    leftRoom(e) {
      // console.log('leftRoom', { e });
    },
    toggleLocalStreamAudioTrack(ref) {
      this.$refs[ref].toggleLocalStreamAudioTrack(this.isLocalStreamMuted);
      this.isLocalStreamMuted = !this.isLocalStreamMuted;
    },
    toggleMutePeers() {
      this.$refs.BlitzarTalk.toggleMutePeers();
      this.allMuted = !this.allMuted;
    },
    toggleLocalStreamVideoTrack() {
      this.$refs.BlitzarMeeting.toggleLocalStreamVideoTrack(this.isLocalStreamDisabled);
      this.isLocalStreamDisabled = !this.isLocalStreamDisabled;
    },
    switchMode() {
      this.switched = !this.switched;
      // this.$refs.BlitzarMeeting.toggleMode(this.switched);
      this.$refs.JitsiMeeting.setTileView();
    },
    contextMenuHandler(e) {
      // console.log('contextMenuHandler', { e });
    },
    chatboxResizing(newRect) {
      this.$refs.sidebox.resized(newRect);
    },
  },
  beforeMount() {
    this.showSpinner = true;
    this.loadActivity();
    this.metaChatbox_x = window.innerWidth - 300;
    this.metaChatbox_y = 360;
  },
  mounted() {
    this.resize();

    window.addEventListener('beforeunload', this.closeWindowConfirm);
    window.addEventListener('message', this.messageReceiver);
    window.addEventListener('resize', this.resize);

    this.updaterInterval = setInterval(() => {
      this.apiGetMeta();
    }, 15000);

    setTimeout(() => {
      if (!this.currentMetaID && !this.$store.state.user.inMeeting) {
        this.blitzarTalkID = this.$route.params.stream;
        this.isUserInLobby = true;
      }
    }, 900);

    this.$root.$on('closeMetaModal', (_) => {
      this.apiGetMeta();
      this.blitzarTalkID = this.$route.params.stream;
      this.isUserInLobby = true;
    });
  },
  beforeDestroy() {
    if (document.getElementById('zoomIframe')) {
      document.getElementById('zoomIframe').contentWindow.postMessage(
        {
          sender: 'logout',
          user: this.$store.state.user.name,
          language: 'pt-PT',
          msg: 'logout',
        },
        '*',
      );
    }

    window.removeEventListener('beforeunload', this.closeWindowConfirm);
    window.removeEventListener('message', this.messageReceiver);
    window.removeEventListener('resize', this.resize);
    clearInterval(this.updaterInterval);
    // this.closeModal();
  },
};
</script>
<style lang="scss">
.meta-section {
  position: relative;
  background-color: var(--main-color);
  background-image: url('https://proto-assets.s3.amazonaws.com/blitzar-demo/assets/meta_bg.jpg');
  background-position: top;
  background-size: contain;
  // background-attachment: fixed;
  background-repeat: no-repeat;
  width: 100%;
  overflow-x: auto;
  // min-height: 100dvh;

  // // SCROLLBAR STYLE
  &::-webkit-scrollbar {
    // display: none;
    width: 8px;
    height: 0px;
  }
  &::-webkit-scrollbar-track {
    background-color: rgb(70, 69, 66);
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(102, 102, 102) !important;
    border-radius: 4px;
    background-image: none !important;
  }

  .meta-header {
    z-index: 2;
  }
}
.base-areas {
  position: relative;
  width: 100%;
  z-index: 0;

  .baseImg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: top;
  }
  .defined-area {
    position: absolute;
    width: calc(100vw / 26);
    height: calc(100vw / 26);
    cursor: pointer;
    .user-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      border-radius: 50%;
    }
    .plus-image {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
      opacity: 0;
      &:hover {
        opacity: 1;
      }
    }
  }
}
.lobby-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 60px;

  @include media('<=phone') {
    padding-top: 50px;
  }
  // background: teal;

  display: flex;
  // flex-wrap: wrap;
  flex-direction: column;
  justify-content: stretch;
  align-items: flex-end;
  z-index: 1;
  pointer-events: none;

  .toolbox-container {
    pointer-events: auto;
    position: relative;
    height: 50px;
    padding: 10px;

    display: flex;
    gap: 20px;
    justify-content: flex-end;
    align-items: center;

    background: #111;
    @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
      background: none;
      -webkit-backdrop-filter: blur(20px) brightness(0.6);
      backdrop-filter: blur(20px) brightness(0.6);
    }
  }

  .avatar-list-container {
    pointer-events: auto;
    position: absolute;
    width: 100%;
    height: 100%;
    // background: transparent;
    display: none;

    img {
      width: 30px;
      height: 30px;
      object-fit: cover;
      border-radius: 50%;
      margin: 0 6px;
    }
  }

  .BlitzarTalk-container {
    pointer-events: auto;
    position: relative;
    max-width: 340px;
  }
}
.meta-modal-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #4446;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease;

  iframe {
    padding: 5% 20% 0 20%;
    @include media('<=1300px') {
      padding: unset;
    }
  }
}
.meta-modal-switch-btn {
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  height: 80px;
  padding: 0 20px 0 0;
  z-index: 10;
  background: #3331;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
}
.meta-modal {
  position: relative;
  height: 100%;
  // width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  background: teal;
}
.meta-user-profile-wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .meta-user-profile-close-btn {
    position: absolute;
    inset: 0;
  }
}
.meta-user-profile-container {
  position: relative;
  min-width: 290px;
  min-height: 50%;
  background: #555;
  border-radius: 30px;

  padding: 40px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  img {
    width: 200px;
    height: 200px;
    object-fit: cover;
    border-radius: 50%;
  }

  label {
    margin: 10px 0;
    font-size: 2rem;
  }
}
.BlitzarMeeting-modal-container {
  position: relative;
  width: 100%;
  height: 100%;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  background: #101010;
  // margin-top: 99px;
  @include media('<=phone') {
    margin-top: 50px;
  }
}
.BlitzarMeeting-tools-btns {
  position: absolute;
  // bottom: 36px; **inline :style**

  display: flex;
  justify-content: space-between;
  gap: 5%;

  i {
    font-size: 2.1rem;
    padding: 10px;
    border-radius: 8000px;
    background: #4444;
    color: #ddd;
    // box-shadow: 0px 0px 8px #444;
    &:active {
      transform: scale(0.85);
    }
  }
}
.meta-chatbox {
  position: absolute;
  min-width: 300px;
  min-height: 300px;
  pointer-events: auto;
}
.meta-chatbox-drag {
  height: 100%;
  width: 100%;
  min-width: 300px;
  height: 50px;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  cursor: move;
}
</style>
